module.exports = __webpack_public_path__ + "img/checks-disabled.540ad1e9.svg";